import { render } from "./CourseOutcomesDetails.vue?vue&type=template&id=54a2e071&scoped=true"
import script from "./CourseOutcomesDetails.vue?vue&type=script&lang=js"
export * from "./CourseOutcomesDetails.vue?vue&type=script&lang=js"

import "./CourseOutcomesDetails.vue?vue&type=style&index=0&id=54a2e071&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a2e071"]])

export default __exports__